/***
 * @Authors:
 *      Ashwin Rai (ashwinrai.com)
 *      Nikhil Chougule
 ***/

/*** Imports ***/
/* Library imports */
import React, {Component} from "react";

/* Component imports */
import ContentLg from "../../../../ContentLg";
import ConstantsLg from "../../../../ConstantsLg";
import TextboxLg from "../../../core/TextboxLg/TextboxLg";

/* Style imports */
import "./styles.css";
/*** End Imports ***/

class SuccessScreen extends Component {
    constructor (props) {
        super(props);
    }

    onTxtBxEmailEditClick = () => {
        this.props.onEmailEditClick();
    };

    render () {
        const {header, message, email} = this.props;

        return (
            <div className={"lg_mdl-freelancer-success"}>
                <div className={"lg_mdl-freelancer-succ-banner"}>
                    <img src={ConstantsLg.URL.GREEN_TICK} />
                </div>
                <p className={"lg_mdl-freelancer-succ-hdr"}>
                    {header}
                </p>
                <p className={"lg_mdl-freelancer-succ-msg"}>
                    {message}
                </p>

                <div className="freelancer-lg-tbpswd-wrpr">
                    <div className="freelancer-lg-tbemail-wrpr">
                        <TextboxLg
                            ref={e=>this.txtBxPswdRef=e}
                            value={email}
                            maxLength={127}
                            isDisabled={true}
                            autoComplete={false}
                        />
                    </div>
                    <i
                        className = "material-icons btn-edit success-popup-btn-edit"
                       onClick = {this.onTxtBxEmailEditClick}
                    >
                        edit
                    </i>
                </div>
            </div>
        );
    }
}

export default SuccessScreen;


// WEBPACK FOOTER //
// ./src/components/RecruiterLogin/components/SuccessScreen/SuccessScreen.js


// WEBPACK FOOTER //
// ./src/components/freelancerLogin/components/SuccessScreen/SuccessScreen.js